var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCovBestLayout = function SvgCovBestLayout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126.1,
    height: 104.706,
    viewBox: "0 0 126.1 104.706",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-849.087 -414.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.187,501.924h-126.1V414.11h126.1v1.8h-124.3v84.214h122.5V424.262h1.8Z",
    transform: "translate(0 0)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.2,486.637H877.777V467.945H911.3v1.8H879.577v15.092H910.4V474.746h1.8Z",
    transform: "translate(17.149 32.179)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,.9H0V-.9H56Z",
    transform: "translate(884.136 517.916)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.559.9H0V-.9H114.559Z",
    transform: "translate(849.987 486.645)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H23.043V50.142H-.9ZM21.243.9H.9V48.342H21.243Z",
    transform: "translate(940.137 426.168)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.435.9H-.9V-.9H3.435Z",
    transform: "translate(862.814 426.168)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.435.9H-.9V-.9H3.435Z",
    transform: "translate(862.814 434.736)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.435.9H-.9V-.9H3.435Z",
    transform: "translate(862.814 443.305)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.435.9H-.9V-.9H3.435Z",
    transform: "translate(862.814 451.873)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.435.9H-.9V-.9H3.435Z",
    transform: "translate(862.814 460.441)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.061.9H-.9V-.9H7.061Z",
    transform: "translate(948.129 434.375)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.061.9H-.9V-.9H7.061Z",
    transform: "translate(948.129 442.758)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.061.9H-.9V-.9H7.061Z",
    transform: "translate(948.129 451.142)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.061.9H-.9V-.9H7.061Z",
    transform: "translate(948.129 459.525)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.061.9H-.9V-.9H7.061Z",
    transform: "translate(948.129 467.909)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.552.9H-.9V-.9H53.552Z",
    transform: "translate(876.074 475.782)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.552.9H-.9V-.9H53.552Z",
    transform: "translate(876.074 426.168)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.546,449.673l-7.513-8-7.513,8-1.312-1.232,8.825-9.393,8.825,9.393Z",
    transform: "translate(22.411 15.153)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.439,453.608l-1.312-1.233,18.708-19.907,10.791,11.354-1.3,1.24-9.479-9.974Z",
    transform: "translate(11.604 11.218)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.994-.9A4.894,4.894,0,1,1-.9,3.994,4.9,4.9,0,0,1,3.994-.9Zm0,7.989A3.094,3.094,0,1,0,.9,3.994,3.1,3.1,0,0,0,3.994,7.089Z",
    transform: "translate(917.445 438.02)",
    fill: "#5680e9"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovBestLayout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cov-best-layout.cff65664.svg";
export { ForwardRef as ReactComponent };